import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private originalMenu: any[] = [];
  private menuSource = new BehaviorSubject<any[] | null>(null);

  currentMenu = this.menuSource.asObservable();

  setFullMenu(menu: any[]) {
    this.originalMenu = menu;
     localStorage.setItem('fullMenu', JSON.stringify(menu));
    this.menuSource.next(menu);
  }

 updateMenuByGroup(group: string | null) {
  if (group) {
    // Step 1: Filter menu by group (Mid)
    const matchedMenus = this.originalMenu.filter(item => item.Mid === group);

    // Step 2: Collect all children into a single flat array
    const mergedChildren = matchedMenus.reduce((acc, item) => {
      if (item.children && item.children.length) {
        acc.push(...item.children);
      }
      return acc;
    }, []);

    // Step 3: Send only child menu to sidebar
    this.menuSource.next(mergedChildren);
  } else {
    // Show full original menu again
    this.menuSource.next(this.originalMenu);
  }
}
getFullMenu(): any[] {
    return this.originalMenu;
  }
  restoreMenuFromStorage() {
    const menuStr = localStorage.getItem('fullMenu');
    if (menuStr) {
      this.originalMenu = JSON.parse(menuStr);
    }
  }
}
